"use client";

import * as React from "react";
import { ChevronDownIcon } from "lucide-react";
import dayjs from "dayjs";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Label } from "@/components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { globalStyleObj } from "@/app/assets/styles";
import { LabelText } from "..";
import { format } from "date-fns";

const CommonDatePicker = ({
  fieldName,
  fieldId,
  value,
  errors,
  errorsType,
  handleDateTimeChange = () => {},
  labelName,
  labelStatus,
  placeholderText = "",
  extraClass = "",
  inputBoxMaxWidth = "max-w-[800px]",
  translateField = false,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div
      className={`${globalStyleObj.commonInputContainerClass} ${extraClass}`}
    >
      <LabelText
        text={labelName}
        htmlForId={fieldId}
        star={labelStatus}
        translateField={translateField}
      />

      <div className={`flex flex-col gap-2 w-full ${inputBoxMaxWidth}`}>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="none"
              id="date"
              className={`flex justify-between gap-2 w-full border border-[#000]/20 font-poppins-rg text-[13px] text-light-weight-400 dark:border-[#fff]/10 dark:bg-[#000]/10 dark:text-light-weight-400`}
            >
              {value ? format(value, "dd/MM/yyyy") : "Select Date"}
              <ChevronDownIcon />
            </Button>
          </PopoverTrigger>

          <PopoverContent className="w-auto overflow-hidden p-0" align="start">
            <Calendar
              initialFocus
              mode="single"
              // selected={value ? dayjs(value) : undefined}
              selected={value ? dayjs(value) : null}
              captionLayout="dropdown"
              onSelect={(selected) => {
                if (selected) {
                  const formated = format(selected, "yyyy-MM-dd");
                  handleDateTimeChange(formated);
                }
                setOpen(false);
              }}
              numberOfMonths={1}
            />
          </PopoverContent>
        </Popover>

        {errors && errorsType && (
          <p className={globalStyleObj.commonInputErrorClass}>
            {errorsType.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default CommonDatePicker;
